import type { ISEOProps } from "../types/core";

export const AcceptableUsePolicyPageSEO: ISEOProps = {
  title: "Acceptable Use Policy - Sugar Cribs",
  description:
    "Read Sugar Cribs Acceptable Use Policy to understand what content and behavior is allowed on our platform.",
};
